import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addInterpretationService = (postData) => {
  return http().post(endpoints.forms.addInterpretation, postData);
};

export function useInterpretationService() {
  return useMutation(addInterpretationService, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
